<template>
    <div v-show="isShow" :style="domStyle" class="ivu-vueTab-div">
        <!-- 请在此添加代码 -->
        
            <!-- <Tabs type="card" ref="tabs">
                <TabPane  v-for="item in tabArray" :key="item.index+new Date().getTime()" :label="item.name" :name="item.name" :id="item.index">
                    <iframe :src="item.value" frameborder="0" :width="domStyle.width" :height='ifHeight' ref="iframe"></iframe>
                </TabPane>
            </Tabs> -->
            <Icon type="ios-arrow-back" ref="isIcon" v-show="iconShow" class="arrow" @click="scrollTab('left')"/>
            <ul :style="tabStyle">
                <li v-for="(item,index) in tabArray"  :class="{active: item.show === true,}" :id="'li'+index" @click="tab(index)">{{item.name}}
                </li>
            </ul>
             <Icon type="ios-arrow-forward" ref="isIcon" v-show="iconShow" class="arrow arrowRight" @click="scrollTab('right')"/>
            <div v-for="(item,index) in tabArray">
             <div v-show="item.show">
                        <iframe :src="item.value" frameborder="0" :width="ifWidth" :height='ifHeight' ref="iframe"></iframe>
                    </div>
            </div>
        <div v-if="isEnable" :style="enableStyle"></div>
    </div>
</template>
<script>
    import $ from 'jquery'
export default {
    name : "",
    props : ["primitives","fvSystemApi","parentObject"],
    created : function(){
        //组件数据混淆
        this.mixin(this.primitives);
        //组件大小位置初始化
        this.domStyle = {
            position : "absolute",
            left : this.x + "px",
            top : this.y + "px",
            width : this.width + "px",
            height : this.height + "px"
        }
        this.enableStyle = {
            position: "absolute",
            width: "100%",
            height: "100%",
            top: "0px",
            backgroundColor: "#ccbfbf",
            opacity: "0.5"
        }
        this.tabStyle={
            fontSize:this.tabFont+'px',
            color:this.tabFontColor,
            background:this.tabBgColor,
        }
        // this.ifWidth=this.width;
        this.tabArray=this.tabList;
        this.tabArray[0].show=true;
        this.modelsPath = this.parentObject.modelsPath.slice(0);
        this.modelsPath.push(this.registerName);
        this.$store.registerModule(this.modelsPath,{
            state : {
                $ : this
            }
        });
       

    },
    watch(){

    },
    mounted() {
        // ;
        let iframe=this.$refs.iframe;
        for(var i=0;i<iframe.length;i++){
            iframe[i].onload=function(){
                window.parent.postMessage({ height: "100px"  }, '*')
            }

        }
        window.addEventListener('message', (event) => {
          const op = event.data
        //   if (op.height) {
        //       this.$refs.iframe.height = op.height
        //   }
      })
    },
    data : function(){
        return {
            //是否可用
            isEnable : false,
            //是否显示
            isShow : true,
            //组件大小位置,在created(创建完毕，挂载前)函数中初始化
            domStyle : {},
            ifHeight:"",
            tabStyle:{},
            tabArray:[],
            ifWidth:"",
            offsetCount:0,
            iconShow:false
        }
    },
    methods : {
       tab(index){
            for(var i=0;i<this.tabArray.length;i++){
                this.tabArray[i].show=false;
                if(i==index){
                    this.tabArray[index].show=true;
                }
            }
        },
         // 滑动tab页签
      scrollTab(direction) {
        if (this.tabArray.length === 0) return
        let menu = this.$el.children[1]
        let ranNum = this.getRanNum();
        //给domo节点添加class
        this.$el.children[1].className += " " + ranNum;
        // 计算ul宽度和当前
        let ulWidth = parseFloat(this.$el.style.width);
        const getWidth = (idName) => {
          let li = document.querySelector(idName)
            return li.clientWidth
        }
        let liWidth = 0
        this.tabArray.forEach((ele, index) => {
          liWidth = liWidth + getWidth(`.${ranNum} #li${index}`)
        });
        // 根据方向和宽度计算偏移量
        if (liWidth < ulWidth) return
        let distance = this.offsetCount * 100

        if (direction === 'left') {
          if (this.offsetCount > 0) {
            this.offsetCount = this.offsetCount - 1
          }
        } else if (direction === 'right') {
          if ((ulWidth + distance) < liWidth) {
            this.offsetCount = this.offsetCount + 1
          }
        }
        distance = this.offsetCount * 100
        menu.scrollTo({
          'left': distance,
          'behavior': 'smooth'
        })
      },
    
        handleIconShow(){
            if (this.tabArray.length === 0) return
            let ranNum = this.getRanNum();
            //给domo节点添加class
            this.$el.children[1].className += " " + ranNum;
            let menu = this.$el.children[1]
            const getWidth = (idName) => {
            let li = document.querySelector(idName)
                return li.clientWidth
            }
            // 计算ul宽度和当前
            let ulWidth = parseFloat(this.$el.style.width);
            let liWidth = 0;
            this.tabArray.forEach((ele, index) => {
                liWidth = liWidth + getWidth(`.${ranNum} li#li${index}`)
            });
            // 根据方向和宽度计算偏移量
            if (liWidth < ulWidth) {
                this.iconShow=false;
                menu.style.width=ulWidth+"px";
            }else{
                this.iconShow=true;
                menu.style.width=ulWidth-54+"px";
            }
        },
        /*
            参数：src 原json数据
            作用：混淆数据到当前对象
        */
        mixin(src) {
            for (var key in src) {
                this[key] = src[key]
            }
        },
        /*
            参数：e 鼠标信息
                 domScale 窗口放大、缩小、偏移等信息
            作用：鼠标事件调用函数，无必要可不进行任何处理
        */
        doFixedEvent(e,domScale){

        },
        /*
            参数：无
            作用：系统周期调用
        */
        onTimer(){
            if(this.isEnable) return;
            this.handleIconShow();
        },
        /*
            参数：无
            作用：所在窗口关闭时调用（vue生命周期函数销毁窗口之前调用）
        */
        onClose(){
            return new Promise((resolve)=>{
                resolve();
            })
        },
        /*
            参数：scaleObj 重绘信息
            作用：组件需要重绘时触发
        */
        reDraw(scaleObj){
            this.domStyle.fontSize = parseInt((12 * (scaleObj.sy + scaleObj.zoom)) + scaleObj.oy) + "px"; 
            this.domStyle.left = parseInt((this.x * (scaleObj.sx + scaleObj.zoom)) + scaleObj.ox) + "px";
            this.domStyle.top  = parseInt((this.y * (scaleObj.sy + scaleObj.zoom)) + scaleObj.oy) + "px";
            this.domStyle.width = parseInt(this.width * (scaleObj.sx + scaleObj.zoom)) + "px";
            this.domStyle.height = parseInt(this.height * (scaleObj.sy + scaleObj.zoom)) + "px";
            this.tabStyle.fontSize=parseInt(this.tabFont * (scaleObj.sy + scaleObj.zoom) + scaleObj.oy) + "px"; 
            // //产生随机字母 
            // var ranNum = this.getRanNum();
            // //给domo节点添加class
            // this.$el.children[0].className +=" "+ranNum;
            // $("."+ranNum+" .ivu-tabs-nav-scroll").append('<style>.'+ranNum+' .ivu-tabs-nav-scroll{color:'+this.tabFontColor+'!important;font-size:'+this.tabStyle.fontSize+';background:'+this.tabBgColor+'}</style>');
            this.ifHeight=parseInt(this.height * (scaleObj.sy + scaleObj.zoom))-52;
             this.$nextTick(() => {
                this.enableStyle.width = this.$el.style.width;
                this.ifWidth=this.$el.style.width;
            });
        },
         //生成随机数
         getRanNum(){
            var result = [];
                for(var i=0;i<4;i++){
                var ranNum = Math.ceil(Math.random() * 25); //生成一个0到25的数字
                    //大写字母'A'的ASCII是65,A~Z的ASCII码就是65 + 0~25;然后调用String.fromCharCode()传入ASCII值返回相应的字符并push进数组里
                    result.push(String.fromCharCode(65+ranNum));
                }
            return  result.join('');
        },
        UpDateData(){

        },
        /*
            作用添加组件标签
        */
        AddUrl(url,param){
            if(url.indexOf('%.')!=-1){
                url=url.replace(/%./g,'/');
            }
            if (url) {
               //判断是否符合http://符合返回真不符合返回假
               var http = /^http:\/\/.*/i.test(url);
               //判断是否符合https://符合返回真不符合返回假
               var https = /^https:\/\/.*/i.test(url);
               //如果两个都为假，我们就为客户添加http://
               if (!http && !https) {
                   url = 'http://' + url;
               }
           }
            this.tabArray.push({"name":param,"value":url,"index":(this.tabArray.length+1),"show":false});
            this.tabArray[0].show=true;
        },
        /*
            删除标签
        */
       isInteger(obj) {
            return obj%1 === 0
        },
        deleteTab(num){
            if (num==="") { 
            console.log("请输入想要删除的标签索引值"); 
            return false; 
            }else if(!(this.isInteger(num))){
            console.log("请输入一个正整数！"); 
            return false; 
            }
            
            this.tabArray.splice(num,1);
            this.tabArray[0].show=true;
            

        },
        /*
            参数：isShow 显示隐藏
            作用：设置组件整体显隐
        */
        Show : function(isShow){
            this.isShow = isShow ? true : false;
        },
        /*
            参数：isEnable 是否可用
            作用：设置组件是否可用
        */
        Enable : function(isEnable){
            this.isEnable = isEnable ? false : true;
        }
    }
}
</script>
<style>
    .ivu-tabs{
        height: 100%;
        /* border: 1px solid #eee; */
    }
    /* 设置颜色字体背景 */
    .ivu-vueTab-div {
        width : 100%;
        height : 100%;
        position: absolute;
        padding : 0;
        overflow: auto;
    }
    .ivu-vueTab-div ul {
            /* width: calc(100% - 54px); */
            overflow: hidden;
            white-space: nowrap;
        }
    .ivu-vueTab-div li{
        list-style: none;
        position: relative;
        display: inline-block;
        margin-right: 20px;
        cursor: pointer;
        border: 1px solid #dcdee2;
        background: #f8f8f9 !important;
        margin-right: 2px;
        padding: 5px 16px 4px;
        border-radius: 4px 4px 0 0;
        text-align:center;
        /* line-height:48px; */
    }
   .ivu-vueTab-div li.active{
        /* background:rgb(51, 172, 172); */
        color: rgb(51, 172, 172);
  }
   .ivu-vueTab-div .arrow {
    font-size: 20px;
    color: #989ba2;
    float:left;
    width: 25px;
    height: 30px;
    border: 1px solid #dad4d8;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  .ivu-vueTab-div .arrow.arrowRight{
      position:absolute;
      right:0;
      top:0;
  }
    .ivu-vueTab-div .ivu-tabs-bar{margin-bottom:2px}
    .ivu-vueTab-div::-webkit-scrollbar-track
    {
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
        border-radius: 10px;
        background-color: #F5F5F5;
    }
    .ivu-vueTab-div .ivu-tabs.ivu-tabs-card>.ivu-tabs-bar .ivu-tabs-tab,.ivu-vueTab-div .ivu-tabs.ivu-tabs-card>.ivu-tabs-bar .ivu-tabs-nav-container {
        height: unset;
    }
    .ivu-vueTab-div::-webkit-scrollbar
    {
        height: 6px;
        width : 6px;
        background-color: #F5F5F5;
    }

    .ivu-vueTab-div::-webkit-scrollbar-thumb
    {
        border-radius: 10px;
        background-image: -webkit-gradient(linear,left bottom,left top,color-stop(0.44, rgb(122,153,217)),color-stop(0.72, rgb(73,125,189)),color-stop(0.86, rgb(28,58,148)));
    }
</style>


// WEBPACK FOOTER //
// src/components/primitives/fvTab/fvTab.vue